module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/ielts/sections/ai/assets/ai_coaching_feature-a3e734539c6d5622290f6cbc0d541a10.png";